module.exports = __webpack_public_path__ + "static/media/patienteducationSelectedIcon.61fe52ee.svg";